import FastMarquee from "react-fast-marquee";
import { Sparkles } from "lucide-react";

const ITEMS = [
    "No coding required",
    "Ship in minutes",
    "AI-powered builder",
    "Websites & web apps",
    "Free to start",
    "You describe it — AI builds it",
];

export const Marquee = () => (
    <section data-testid="editorial-marquee" className="overflow-hidden border-y border-white/10 py-8 sm:py-10">
        <FastMarquee speed={32} gradient={false} pauseOnHover>
            {ITEMS.map((item, i) => (
                <span key={item} className="mx-6 flex items-center gap-12 sm:mx-8">
                    <span
                        className={`whitespace-nowrap font-display text-2xl font-light tracking-tight sm:text-3xl ${
                            i % 2 === 0 ? "text-white/90" : "text-outline"
                        }`}
                    >
                        {item}
                    </span>
                    <Sparkles size={18} strokeWidth={1.5} className="shrink-0 text-[#8B5CF6]" />
                </span>
            ))}
        </FastMarquee>
    </section>
);
